import { BaseJsonSchema, createSchemaByBasicTypes } from "../../../helpers";

export const TheTraderDeskBidSchema: BaseJsonSchema = {
  type: "object",
  properties: {
    bidder: {
      type: "string",
      enum: ["ttd"],
    },
    params: {
      type: "object",
      properties: {
        supplySourceId: createSchemaByBasicTypes("string", null, {
          additionalProperties: false,
        }),
        publisherId: createSchemaByBasicTypes("string", null, {
          additionalProperties: false,
        }),
        placementId: createSchemaByBasicTypes("string", null, {
          additionalProperties: false,
        }),
      },
      required: ["supplySourceId", "publisherId"],
    },
  },
  additionalProperties: false,
  required: ["bidder", "params"],
};
